import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';

import {ActivatedRoute} from '@angular/router';
import {OwlOptions} from 'ngx-owl-carousel-o';
import {BreadcrumbModel} from '../../../shared/models/Breadcrumb.class';
import {ProductDataSet} from '../../models/product-data-set';
import {RegistryService} from '../../services/registry.service';
import {ProductsGridComponent} from '../products/products-grid/products-grid.component';
import {Title} from "@angular/platform-browser";
import {GoogleAnalyticsService} from "../../services/google-analytics.service";

@Component({
    selector: 'app-categories',
    templateUrl: './categories.component.html',
    styleUrls: ['./categories.component.css']
})
export class CategoriesComponent implements OnInit, AfterViewInit, OnDestroy {

    constructor(private route: ActivatedRoute,
                private titleService: Title,
                private googleService: GoogleAnalyticsService,
                public registry: RegistryService) {
    }


    FullCategories: any = [];
    Cat: any;
    subCat: any = [];
    isLoading = false;
    id;
    path;
    children: any = [];
    breadScrumb: any = [];
    pathArr: any = [];
    breadScrumbArr: any = [];
    ProductDataSet: ProductDataSet = new ProductDataSet();

    noChildren = false;
    categoriesLoadedEvent = null;

    customOptions: OwlOptions = {
        loop: false,
        mouseDrag: true,
        touchDrag: true,
        pullDrag: false,
        lazyLoad: true,
        margin: 0,
        navSpeed: 200,
        nav: true,
        autoHeight: true,
        autoWidth: false,
        slideBy: '4',
        responsive: {
            0: {
                items: 1
            },
            400: {
                items: 2
            },
            740: {
                items: 3
            },
            940: {
                items: 4
            }
        }
    };

    ngOnDestroy(): void {
        if (this.categoriesLoadedEvent != null) {
            this.categoriesLoadedEvent.unsubscribe();
        }
    }


    ngOnInit(): void {

        this.id = this.route.snapshot.paramMap.get('id');
        this.FullCategories = this.registry.getFullCat();
        this.getCategories();
        this.getSubCatagories();
        this.getPathCategories();

     //   if(this.FullCategories == null) {
            this.categoriesLoadedEvent = this.registry.CatsLoadedEvent$.subscribe(result => {


                this.FullCategories = [];
                this.subCat = [];
                this.path = null;
                this.pathArr = [];
                this.breadScrumb = [];
                this.breadScrumbArr = []
                this.FullCategories = result;
                this.getCategories();
                this.getSubCatagories();
                this.getPathCategories();
                this.googleService.eventEmitter("category_view", 'ecommerce', 'category_view', this.Cat[0].name + " " + this.id);

            });
       // }

        this.ProductDataSet.pushParams('category_id', this.id, 'eq');

    }


    getCategories() {
        if (this.FullCategories) {
            this.Cat = this.FullCategories.filter(v => v.id === Number(this.id));

            return this.Cat;
        } else {
            return null;
        }

    }

    getSubCatagories() {

        if (this.Cat != null && this.Cat.length != 0) {
            this.children = this.Cat[0].children.split(',');
            this.children.forEach(e =>
                this.subCat = this.subCat.concat(this.FullCategories.filter(v => v.id === Number(e)))
            )
            this.isLoading = true;
        }


    }

    getPathCategories() {
        this.breadScrumb = [];


        if (this.Cat == null) {
            return;
        }

        this.titleService.setTitle("Alarabiya العربية - " + this.Cat[0]?.name);


        if(this.Cat[0] != null) {

            this.path = this.Cat[0]?.path;
            this.pathArr = this.path.split('/');
            this.pathArr.forEach(e =>
                this.breadScrumb = this.breadScrumb.concat(this.FullCategories.filter(v => v.id === Number(e)))
            );
            this.breadScrumb.forEach(e =>
                this.breadScrumbArr.push(new BreadcrumbModel(e.name, '/web/home/categories/' + e.id))
            );

            this.breadScrumbArr.splice(0, 1);
        }

    }

    ngAfterViewInit(): void {

        // this.ProductDataSet.pushParams('category_id', this.Cat[0].children, 'in');
        // this.gridComponent.setProductDataset(this.ProductDataSet);
        // this.gridComponent.fetchProductDataSet();
    }

}
